export default {
  title: "Documents",
  instruction: "Instruction",
};
